import React from 'react';
import classes from "./TeamTitle.module.css";

export default function TeamTitle() {
    return (
        <div className={classes.team_title}>
            <h2>TEAM</h2>
            <div className={classes.frame}>
                <svg width="156" height="71" viewBox="0 0 156 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.92578 4.01581C54.4047 23.8009 105.192 45.3308 154.074 68.5151C120.855 45.0279 82.8804 24.4202 41.1366 7.22635C78.8244 15.1086 112.382 29.0144 145.516 42.7711C129.239 29.6745 110.898 17.6615 90.7745 6.91822L142.344 21.649C138.879 15.267 132.582 9.6522 124.207 5.47694L145.971 11.3712L139.91 2.48505" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </div>
    )
}
